import { render } from "./Invoicing.vue?vue&type=template&id=308ae634&scoped=true"
import script from "./Invoicing.vue?vue&type=script&lang=js"
export * from "./Invoicing.vue?vue&type=script&lang=js"

import "./Invoicing.vue?vue&type=style&index=0&id=308ae634&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308ae634"]])

export default __exports__